module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "padding-top": "20px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3"
  }, [_c('menu-lateral')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-9 col-lg-9"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 text-right"
  }, [(_vm.user.sucursalesAdministradas.length > 1) ? _c('div', [_c('b', {
    staticClass: "text-brand"
  }, [_vm._v("Sucursal")]), _vm._v(" "), _c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn btn-brand dropdown-toggle",
    attrs: {
      "data-toggle": "dropdown",
      "id": "dd1",
      "aria-expanded": "true"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.sucursal.denominacion) + "  "), _c('i', {
    staticClass: "fa fa-angle-down"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu super",
    attrs: {
      "aria-labelledby": "dd1"
    }
  }, _vm._l((_vm.user.sucursalesAdministradas), function(suc) {
    return _c('li', [_c('a', {
      attrs: {
        "href": '#/usuarios/sucursal/' + suc
      },
      on: {
        "click": function($event) {
          _vm.cambiarSucursal(_vm.getSucursal(suc))
        }
      }
    }, [_vm._v(_vm._s(_vm.getSucursal(suc).denominacion))])])
  }))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "box-style line-top"
  }, [_c('div', {
    staticClass: "panel-group smart-accordion-default",
    attrs: {
      "id": "accordion"
    }
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "panel-title box-header"
  }, [_c('a', {
    attrs: {
      "data-toggle": "collapse",
      "href": "#panel1"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-angle-down pull-right"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-lg fa-angle-up pull-right"
  }), _vm._v(" "), _c('div', {
    staticClass: "box-date"
  }, [_vm._v(_vm._s(_vm.usuariosInvitados.length) + " invitaciones enviadas")]), _vm._v(" "), _c('h2', [_vm._v("INVITACIONES")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse in",
    attrs: {
      "id": "panel1"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "table-header form smart-form"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.findInvitado),
      expression: "findInvitado"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Búsqueda rápida"
    },
    domProps: {
      "value": (_vm.findInvitado)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.findInvitado = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-4 pull-right text-right"
  }, [_c('router-link', {
    staticClass: "btn btn-fill",
    attrs: {
      "to": "/invitarusuarios"
    }
  }, [_vm._v("NUEVA INVITACIÓN")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "table-container"
  }, [_c('table', {
    staticClass: "table table-hover table-stripped table-no-first-pad"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.invitadosFiltrados), function(usuario) {
    return _c('tr', {
      key: usuario._id
    }, [_c('td', [_vm._v(_vm._s(usuario.firstName) + " " + _vm._s(usuario.lastName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(usuario.email))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatearFecha")(usuario.fecha)))]), _vm._v(" "), _c('td', [_c('ul', {
      staticClass: "table-actions smart-form"
    }, [_c('li', [_c('a', {
      staticClass: "btn btn-xs btn-ghost",
      attrs: {
        "href": "",
        "type": "button"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onClickEliminarInvitado(usuario._id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-actions fa-times"
    })])])])])])
  }))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "panel-title box-header subline-top"
  }, [_c('a', {
    attrs: {
      "data-toggle": "collapse",
      "href": "#panel2"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-angle-down pull-right"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-lg fa-angle-up pull-right"
  }), _vm._v(" "), _c('div', {
    staticClass: "box-date"
  }, [_vm._v(_vm._s(_vm.usuariosRegistrados.length) + " usuarios ")]), _vm._v(" "), _c('h2', [_vm._v("USUARIOS")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse in",
    attrs: {
      "id": "panel2"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "table-header form smart-form"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-8"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.findUsuario),
      expression: "findUsuario"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Búsqueda rápida"
    },
    domProps: {
      "value": (_vm.findUsuario)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.findUsuario = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(3)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-4 pull-right text-right"
  }, [_c('a', {
    staticClass: "btn btn-fill",
    attrs: {
      "href": '#/newuser/' + _vm.sucursal._id
    }
  }, [_vm._v("NUEVO USUARIO")])])])]), _vm._v(" "), _c('div', {
    staticClass: "table-container"
  }, [_c('table', {
    staticClass: "table table-hover table-stripped table-no-first-pad"
  }, [_vm._m(4), _vm._v(" "), _vm._l((_vm.usuariosFiltrados), function(usuario, idx) {
    return _c('tbody', {
      key: usuario._id
    }, [_c('tr', [_c('td', [_vm._v("\n                            " + _vm._s(usuario.displayName) + "\n                            "), (usuario.roles[0] === 'admincliente') ? _c('span', {
      staticClass: "label label-admin"
    }, [_vm._v("ADMIN")]) : _vm._e(), _vm._v(" "), (!usuario.activado) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("INACTIVO")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(usuario.email))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "100px"
      }
    }, [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!usuario.editing),
        expression: "!usuario.editing"
      }],
      on: {
        "click": function($event) {
          _vm.toggleEdit(_vm.ev, usuario, idx)
        }
      }
    }, [_vm._v(_vm._s(usuario.legajo ? usuario.legajo : "Editar"))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (usuario.legajo),
        expression: "usuario.legajo"
      }, {
        name: "show",
        rawName: "v-show",
        value: (usuario.editing),
        expression: "usuario.editing"
      }],
      staticClass: "form-control form-control-sm",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (usuario.legajo)
      },
      on: {
        "blur": function($event) {
          _vm.saveEditLegajo(_vm.ev, usuario, idx)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          usuario.legajo = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('td', [(!usuario.editarSucursal) ? _c('span', [_vm._v(_vm._s(usuario.sucursalAsociada.denominacion))]) : [_c('div', {
      staticClass: "input-group input-group-sm"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (usuario.nuevaSucursal),
        expression: "usuario.nuevaSucursal"
      }],
      staticClass: "form-control",
      domProps: {
        "value": usuario.sucursalAsociada._id
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          usuario.nuevaSucursal = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, _vm._l((_vm.sucursales), function(sucursal) {
      return _c('option', {
        key: sucursal._id,
        domProps: {
          "value": sucursal._id
        }
      }, [_vm._v(_vm._s(sucursal.denominacion))])
    })), _vm._v(" "), _c('span', {
      staticClass: "input-group-addon btn btn-fill",
      on: {
        "click": function($event) {
          _vm.onClickCambiarSucursal(usuario)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-check",
      attrs: {
        "aria-hidden": "true"
      }
    })])])]], 2), _vm._v(" "), _c('td', [(_vm.user._id !== usuario._id) ? _c('ul', {
      staticClass: "table-actions smart-form"
    }, [(usuario.roles[0] === 'user' && usuario.activado) ? _c('li', [_c('a', {
      staticClass: "btn btn-xs btn-ghost",
      attrs: {
        "type": "button",
        "title": "Hacer admin"
      },
      on: {
        "click": function($event) {
          _vm.onClickCambiarRol(usuario._id, 'admincliente', usuario)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-users",
      attrs: {
        "aria-hidden": "true"
      }
    })])]) : _vm._e(), _vm._v(" "), (usuario.roles[0] === 'admincliente') ? _c('li', [_c('a', {
      staticClass: "btn btn-xs btn-ghost",
      attrs: {
        "type": "button",
        "title": "Hacer usuario normal"
      },
      on: {
        "click": function($event) {
          _vm.onClickCambiarRol(usuario._id, 'user', usuario)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-user-o",
      attrs: {
        "aria-hidden": "true"
      }
    })])]) : _vm._e(), _vm._v(" "), (usuario.activado) ? _c('li', [_c('a', {
      staticClass: "btn btn-xs btn-ghost",
      attrs: {
        "type": "button",
        "title": "Desactivar"
      },
      on: {
        "click": function($event) {
          _vm.onClickCambiarActivo(usuario._id, false)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-actions fa-user-times"
    })])]) : _c('li', [_c('a', {
      staticClass: "btn btn-xs btn-ghost",
      attrs: {
        "type": "button",
        "title": "Activar"
      },
      on: {
        "click": function($event) {
          _vm.onClickCambiarActivo(usuario._id, true)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-actions fa-user-plus"
    })])]), _vm._v(" "), _c('li', [_c('a', {
      staticClass: "btn btn-xs btn-ghost",
      attrs: {
        "type": "button",
        "title": "Cambiar sucursal"
      },
      on: {
        "click": function($event) {
          _vm.toggleCambiarSucursal(usuario)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-building-o"
    })])])]) : _vm._e()])])])
  })], 2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "panel-title box-header subline-top"
  }, [_c('a', {
    attrs: {
      "data-toggle": "collapse",
      "href": "#panel2"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-angle-down pull-right"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-lg fa-angle-up pull-right"
  }), _vm._v(" "), _c('div', {
    staticClass: "box-date"
  }, [_vm._v(_vm._s(_vm.usuariosAdministradores.length) + " usuarios ")]), _vm._v(" "), _c('h2', [_vm._v("ADMINISTRADORES")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse in",
    attrs: {
      "id": "panel2"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "table-header form smart-form"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-8"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-4 pull-right text-right"
  }, [_c('a', {
    staticClass: "btn btn-fill",
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.abrirModalAdmins()
      }
    }
  }, [_vm._v("AGREGAR ADMINISTRADOR")])])])]), _vm._v(" "), _c('div', {
    staticClass: "table-container"
  }, [_c('table', {
    staticClass: "table table-hover table-stripped table-no-first-pad"
  }, [_vm._m(5), _vm._v(" "), _vm._l((_vm.usuariosAdministradores), function(usuario, idx) {
    return _c('tbody', {
      key: usuario._id
    }, [_c('tr', [_c('td', [_vm._v("\n                            " + _vm._s(usuario.displayName) + "\n                            "), (usuario.roles[0] === 'admincliente') ? _c('span', {
      staticClass: "label label-admin"
    }, [_vm._v("ADMIN")]) : _vm._e(), _vm._v(" "), (!usuario.activado) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("INACTIVO")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(usuario.email))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "100px"
      }
    }, [_c('span', [_vm._v(_vm._s(usuario.legajo ? usuario.legajo : ""))])]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(usuario.sucursalAsociada.denominacion))])]), _vm._v(" "), _c('td', [(_vm.user._id !== usuario._id) ? _c('ul', {
      staticClass: "table-actions smart-form"
    }, [(usuario.roles[0] === 'user' && usuario.activado) ? _c('li', [_c('a', {
      staticClass: "btn btn-xs btn-ghost",
      attrs: {
        "type": "button",
        "title": "Hacer admin"
      },
      on: {
        "click": function($event) {
          _vm.onClickCambiarRol(usuario._id, 'admincliente', usuario)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-users",
      attrs: {
        "aria-hidden": "true"
      }
    })])]) : _vm._e(), _vm._v(" "), (usuario.roles[0] === 'admincliente') ? _c('li', [_c('a', {
      staticClass: "btn btn-xs btn-ghost",
      attrs: {
        "type": "button",
        "title": "Hacer usuario normal"
      },
      on: {
        "click": function($event) {
          _vm.onClickCambiarRol(usuario._id, 'user', usuario)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-user-o",
      attrs: {
        "aria-hidden": "true"
      }
    })])]) : _vm._e(), _vm._v(" "), (usuario.activado) ? _c('li', [_c('a', {
      staticClass: "btn btn-xs btn-ghost",
      attrs: {
        "type": "button",
        "title": "Desactivar"
      },
      on: {
        "click": function($event) {
          _vm.onClickCambiarActivo(usuario._id, false)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-actions fa-user-times"
    })])]) : _c('li', [_c('a', {
      staticClass: "btn btn-xs btn-ghost",
      attrs: {
        "type": "button",
        "title": "Activar"
      },
      on: {
        "click": function($event) {
          _vm.onClickCambiarActivo(usuario._id, true)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-actions fa-user-plus"
    })])])]) : _vm._e()])])])
  })], 2)])])])])])])])]), _vm._v(" "), _c('div', {
    ref: "modalAdministradores",
    staticClass: "modal",
    attrs: {
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "smart-form"
  }, [(_vm.loadingAdmins) ? _c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('i', {
    staticClass: "fa fa-cog fa-spin fa-3x fa-fw"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-12 "
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.findAdmin),
      expression: "findAdmin"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Búsqueda rápida"
    },
    domProps: {
      "value": (_vm.findAdmin)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.findAdmin = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(7)])])]), _vm._v(" "), _vm._l((_vm.adminsFiltrados), function(admin) {
    return (!_vm.loadingAdmins) ? _c('div', {
      staticClass: "form-group"
    }, [_c('a', {
      attrs: {
        "href": ""
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.toggleAdmin(admin)
        }
      }
    }, [(_vm.adminDeEstaSucursal(admin)) ? _c('i', {
      staticClass: "fa fa-check-square-o"
    }) : _c('i', {
      staticClass: "fa fa-square-o"
    })]), _vm._v(" "), _c('span', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.toggleAdmin(admin)
        }
      }
    }, [_vm._v(_vm._s(admin.displayName))])]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "text-center center-block"
  }, [_c('button', {
    staticClass: "btn btn-fill",
    on: {
      "click": function($event) {
        _vm.cerrarModal()
      }
    }
  }, [_vm._v("Guardar")])])])], 2)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4"
  }, [_c('ul', {
    staticClass: "breadcrumbs",
    staticStyle: {
      "position": "initial",
      "top": "0px"
    }
  }, [_c('li', [_vm._v("Administración")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-angle-right"
  })]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Usuarios")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Nombre")]), _vm._v(" "), _c('th', [_vm._v("E-mail")]), _vm._v(" "), _c('th', [_vm._v("Fecha invitación")]), _vm._v(" "), _c('th')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Nombre")]), _vm._v(" "), _c('th', [_vm._v("Email")]), _vm._v(" "), _c('th', [_vm._v("Legajo")]), _vm._v(" "), _c('th', [_vm._v("Sucursal")]), _vm._v(" "), _c('th', {
    staticClass: "derecha"
  }, [_vm._v("Acciones")]), _vm._v(" "), _c('th')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Nombre")]), _vm._v(" "), _c('th', [_vm._v("Email")]), _vm._v(" "), _c('th', [_vm._v("Legajo")]), _vm._v(" "), _c('th', [_vm._v("Sucursal")]), _vm._v(" "), _c('th', {
    staticClass: "derecha"
  }, [_vm._v("Acciones")]), _vm._v(" "), _c('th')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("ADMINISTRADORES DISPONIBLES EN LA EMPRESA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9e2ad4fe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/User/Usuarios.vue
// module id = 1160
// module chunks = 5